import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { TdDataTableTemplateDirective } from '@covalent/core/data-table/directives/data-table-template.directive';

import { Patron } from '../../../../models';

import { PatronesService, LoginService } from '../../../../services/';
import { AltaCerradosComponent } from './altacerrados/altacerrados.component';

@Component({
  selector: 'qs-cerrados',
  templateUrl: './cerrados.component.html',
  styleUrls: ['./cerrados.component.scss'],
  viewProviders: [PatronesService],
})

// TODO: SACAR LA ASIGNACIÓN DE TIPO DE PATRON A UN ENUMERADO
export class CerradosComponent implements AfterViewInit, OnInit, OnDestroy {

  private idPaciente: string;
  private patrones: Patron[];
  private _xsScreen: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'idPatron', label: 'id', hidden: true },
    { name: 'textoPatron', label: 'Título', tooltip: 'Título', sortable: true },
    { name: 'tipoPatron', label: 'Tipo', tooltip: 'Tipo', sortable: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: Patron[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _patronesService: PatronesService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('cerrados.load');

    this._patronesService.obtenerListadoValoracionesPaciente(1,
      this._loginService.consulta.numeroExpediente,
      false,
    ).subscribe((res: any) => {
      this.patrones = res.respuesta;
      this._patronesService.obtenerListadoValoracionesPaciente(2,
        this._loginService.consulta.numeroExpediente,
        false,
      ).subscribe((resp: any) => {
           this.patrones.push.apply(this.patrones, resp.respuesta);

           this._patronesService.obtenerListadoValoracionesPaciente(5,
            this._loginService.consulta.numeroExpediente,
            false,
          ).subscribe((respu: any) => {
              this.patrones.push.apply(this.patrones, respu.respuesta);

              for (let i: any = 0; i < this.patrones.length; i++) {
                if (this.patrones[i].tipoPatron === '1') {
                  this.patrones[i].descripcionPatron = 'Patrón funcional';
                } else if (this.patrones[i].tipoPatron === '2') {
                  this.patrones[i].descripcionPatron = 'Programa de salud';
                } else if (this.patrones[i].tipoPatron === '5') {
                  this.patrones[i].descripcionPatron = 'Test';
                }
              }

              this.filteredData = this.patrones;
              this.filteredDataTotal = this.patrones.length;
              this._loadingService.resolve('cerrados.load');
          }, (error: Error) => {
            this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
            this._loadingService.resolve('cerrados.load');
          });

      }, (error: Error) => {
        this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
        this._loadingService.resolve('cerrados.load');
      });

    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo motivos de consulta.', 'OK', 6000);
      this._loadingService.resolve('cerrados.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   * xs < 600px
   * sm > 600px
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
        }
      });
    });
  }

  /**
   * openDetalle: Muestra la vista de detalle pasando la linea seccionada
   * @param any: $event <- Fila seleccionada
   */
  openDetalle(patron: Patron): void {
    if (patron) {
      this._loginService.transient = patron;
      this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/modanamnesis',
      { outlets: { modanamnesis: ['cerradosdetalle'] } }]);
    }
  }

  /**
   * Abre una vista detalle de la consulta
   * @param tecnica
   */

  openDetail(patron: any): void {
     let dialogRef: any = this._dialogService.open( AltaCerradosComponent, {
       data: patron,
       width: '92%',
       role: 'dialog',
       height: '90%',
     });
     dialogRef.componentInstance.patron = patron;
     dialogRef.componentInstance.titulo = patron.name;
     dialogRef.componentInstance.idPatron = patron.id;
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.patrones;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/cerrados/cerrados.component.ts